<template>
  <div class="home_container">
    <swiper
      :list="list"
    />
    <js-title
      zh="国内网点地图"
      en="Branch Map"
    />
    <js-map />
    <js-title
      zh="为什么选择我们"
      en="Company Advantage"
    />
    <advantage />
    <js-title
      zh="服务项目"
      en="Our Service"
    />
    <service />
    <about />
  </div>
</template>

<script>
import JsTitle from '@/packages/JsTitle.vue'
import Swiper from './components/Swiper'
import Advantage from './components/Advantage'
import Service from './components/Service'
import About from './components/About'
import JsMap from './components/JsMap'
export default {
  name: 'home',
  components: {
    JsTitle,
    Swiper,
    Advantage,
    Service,
    About,
    JsMap
  },
  data () {
    return {
      list: [{
        id: this.uuid(),
        url: '/img/home/banner1.jpg',
        to: '/project/express',
        alt: '速递业务'
      }, {
        id: this.uuid(),
        url: '/img/home/banner2.jpg',
        to: '/project/air-freight',
        alt: '空运'
      }, {
        id: this.uuid(),
        url: '/img/home/banner3.jpg',
        to: '/project/shipping',
        alt: '海运'
      }, {
        id: this.uuid(),
        url: '/img/home/banner4.jpg',
        to: '/project/cross-border',
        alt: '跨境电商'
      }, {
        id: this.uuid(),
        url: '/img/home/banner5.jpg',
        to: '/project/internal-trade',
        alt: '内贸运输'
      }]
    }
  },
  methods: {
    uuid () {
      var s = []
      var hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'
      var uuid = s.join('')
      return uuid
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
